export default __webpack_public_path__ + "app/assets/daweiCatLtoR-12db8b7d.gif";